document.querySelectorAll('.review-card').forEach((card) => {
    const content = card.querySelector('.review-card__content');
    const footer = card.querySelector('.review-card__footer');

    if (content.scrollHeight > content.clientHeight) {
        footer.hidden = false;
    }
});

document.addEventListener('click', (event) => {
    const button = event.target.closest('.review-card__more');

    if (!button) {
        return;
    }

    const card = button.closest('.review-card');
    const content = card.querySelector('.review-card__content');
    const footer = card.querySelector('.review-card__footer');

    content.classList.add('is-expanded');

    if (footer) {
        footer.remove();
    }
});
